import { VideoTracker } from '@/utils/tracking/videoTracking'
import { ConnatixPlayerApi } from '@/connatix/connatixTypes'

type ConnatixTracker = (
    eventName: string,
    filteredEventData?: Record<string, string | number>,
) => void

export function createConnatixTrack(
    renderId: string,
    playerApi: ConnatixPlayerApi,
    videoTracker: VideoTracker,
): ConnatixTracker {
    return (eventName, filteredEventData) => {
        videoTracker.track({
            player_element_id: renderId,
            event_name: eventName,
            video_player: playerApi.getApiConfig().playerId,
            video_player_is_viewable: playerApi.isViewable(),
            ...filteredEventData,
        })
    }
}

export function handlePlayerTracking(
    playerApi: ConnatixPlayerApi,
    track: ConnatixTracker,
) {
    playerApi.on('videoCompleted100', () => track('video_content_completed'))
    playerApi.on('videoStarted', () => track('video_content_start'))
    playerApi.on('closeButtonClicked', () => track('video_player_close'))
    playerApi.on('playerFloatChanged', () => track('video_pip'))
    playerApi.on('isViewable', () => track('video_player_viewability_state'))
}

export function handleAdsTracking(
    playerApi: ConnatixPlayerApi,
    track: ConnatixTracker,
) {
    playerApi.on('adCompleted100', () => track('video_ad_completed'))
    playerApi.on('adPlay', () => track('video_ad_started'))
    playerApi.on('adImpression', (data) => {
        return track('video_ad_loaded', {
            video_ad_position: data.adBreakType,
        })
    })
}
